<template>
    <div class="animated fadeIn apInvoiceDetail bgV2">
        <b-row class="p-20 pr-4">
            <b-col md="12">
                <div class="d-flex headerComponent justify-content-between align-items-end">
                    <h3 class="title">{{apInvoice ? apInvoice.invoice_number:''}}</h3>
                    <span class="status mr-3">{{apInvoice ? apInvoice.status:''}}</span>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="12">
                <gofix-tab
                        class="mt-3"
                        :data="tabData">
                    <template slot="gofixTab:right">
                        <gofix-button
                            label="Cancel"
                            @click="btnCallFnChangePV(1)"
                            :disabled="!!this.apInvoice.payment_voucher || this.apInvoice.status === 'Cancelled' || btnLoading.cancel || btnLoading.global"
                            v-if="!$disabledCreateOrUpdate(this.apInvoice, $accessModule.ap_invoice)" outline />
                        <gofix-button
                            class="mr-3 ml-3"
                            v-if="!$disabledCreateOrUpdate(this.apInvoice, $accessModule.ap_invoice)"
                            :disabled="(!!this.apInvoice.payment_voucher || 
                            this.apInvoice.status !== 'Verified' ||  
                            btnLoading.submitAndRaise || 
                            btnLoading.global || !$checkRole($accessModule.ap_raise_pv, 'raise_pv'))"
                            label="Raise PV"
                            @click="btnCallFnChangePV(2)"
                            :loading="btnLoading.submitAndRaise" outline />
                        <gofix-button
                            label="Submit"
                            v-if="!$disabledCreateOrUpdate(this.apInvoice, $accessModule.ap_invoice)"
                            :disabled="!!this.apInvoice.payment_voucher || this.apInvoice.status !== 'Draft' || btnLoading.submit || btnLoading.global"
                            @click="btnCallFnChangePV(3)"
                            :loading="btnLoading.submit" outline />
                    </template>
                    <template slot="gofixTab:basic-info">
                        <ap-info ref="appinfo" :lmu="conditionLMUContract()" />
                    </template>
                    <template slot="gofixTab:activity-log">
                        <activities ref="itemActivities" activityType="AP Invoice" :activityId="$route.params.apinvoice_id" />
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    const apInfo = () => import("./detail-info")
    const Activities = () => import("../../global/Activities")
    import moment from 'moment';

    export default {
        name: 'ap-invoice-detail',
        components: {
            apInfo,
            Activities
        },
        data() {
            return {
                tabData:[
                    {
                        key: "basic-info",
                        title: "Invoice Info",
                        active: true
                    },
                    {
                        key: "activity-log",
                        title: "Activity Log",
                        active: false
                    },
                ],
                btnLoading:{
                    global: false,
                    cancel: false,
                    submit: false,
                    submitAndRaise: false
                }
            }
        },
        watch: {
            apInvoice: function(val) {
                // callback Contract selector
                if(val && val.client_contract_id && (!this.ClientContractID || !this.ClientContractID.id || (this.ClientContractID && this.ClientContractID.id && this.ClientContractID.id != val.client_contract_id))) {
                    this.$store.dispatch( 'ContractController/getClientContractID', val.client_contract_id).then(response => {
                        localStorage.setItem("ClientContractID", JSON.stringify(response.data.data));
                    })
                }
            }
        },
        computed: {
            ...mapGetters({
                apInvoice: 'ApInvoiceController/Item',
                ClientContractID: 'ContractController/ClientContractID',
                UserLogin: 'AuthController/user'
            }),
        },
        created() {
            this.getApInvoiceDetail();
        },
        mounted() {},
        methods: {
            /*-------- get data ----------------*/
            getApInvoiceDetail(){
                this.$store.dispatch('ApInvoiceController/getApInvoice', {
                    id: this.$route.params.apinvoice_id
                });
            },
            /* ----- Save data -------------------*/
            saveData(data){
                this.$store.dispatch(`ApInvoiceController/updateApInvoice`, data)
                    .then( response => {
                        this.$alertNotification(this.$notificationV2('editing', 'ap_invoice'));
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            raisePv(){
                let request = {};
                request.pv_date = moment(new Date()).format('YYYY-MM-DD');
                request.status = 'Under Approval';
                request.pay_to_id = this.apInvoice.supplier_id;
                request.pay_to_type = "Supplier";
                request.client_contract_id = this.apInvoice.client_contract_id;
                request.ap_invoice_ids = [this.apInvoice.id];
                request.from_raise = "AP Invocie";
                this.$store.dispatch(`PaymentVoucherController/createPayment`, request)
                    .then(async response => {
                        setTimeout(() => {
                            this.$alertNotification(this.$notificationV2('adding', 'payment_voucher'));
                            this.getApInvoiceDetail();
                            this.$router.push('/v2/payment-voucher/' + response.data.data.id)
                        },3000)
                    })
                    .catch(error => {})
            },
            async btnCallFnChangePV(type){
                if(this.btnLoading.global) return;
                let data = {
                    status: null,
                    id: this.apInvoice.id
                };
                this.btnLoading.global = true;
                switch (type) {
                    case 1:
                        data.status = "Cancelled";
                        data.activity_action = "Cancel";
                        this.btnLoading.cancel = true;
                        await this.saveData(data);
                        this.btnLoading.cancel = false;
                        break;
                    case 2:
                        if(this.apInvoice.line_item.length === 0 ) {
                            this.btnLoading.global = false;
                            return this.$alertNotification("Please add a AP Invoice Line item", "danger");
                        }
                        this.btnLoading.submitAndRaise = true;
                        data = {
                            activity_action : "Raise PV",
                            id: this.apInvoice.id
                        };
                        await this.saveData(data);
                        await this.raisePv();
                        this.btnLoading.submitAndRaise = false;
                        break;
                    case 3:
                        if(this.apInvoice.line_item.length === 0 ) {
                            this.btnLoading.global = false;
                            return this.$alertNotification("Please add a AP Invoice Line item", "danger");
                        }

                        data.status = "Pending Verification";
                        //LMUf
                        if(this.conditionLMUContract()){
                            data.status = "Verified";
                        }
                        data.activity_action = "Submit";
                        this.btnLoading.submit = true;
                        await this.saveData(data);
                        this.btnLoading.submit = false;
                        break;
                }
                this.btnLoading.global = false;
            },
            conditionLMUContract(){
                if(this.UserLogin.organization && this.UserLogin.organization.is_supplier){
                    if(this.apInvoice && (!this.apInvoice.supplier_contract || 
                    (this.apInvoice.supplier_contract && 
                    !this.apInvoice.supplier_contract.is_supplier_under_lmu_project))
                    )
                        return false;
                    if(!this.apInvoice.supplier_contract.lmu_settings || 
                    (this.apInvoice.supplier_contract.lmu_settings && 
                    !this.apInvoice.supplier_contract.lmu_settings.allow_supplier_add_ap_line_item_without_verification)
                    )
                        return false;
                    return true;
                }
                return false;
            }
        }
    }
</script>

